import { timeline } from '@/api/timelines'
import store from '@/store'

let res = null

export const timelines = {
    namespaced: true,
    state: {
        // base on staff time schedule on timeline
        staffs: null,
        schedules: null,
        recipients: null,

        // base on recipient time schedule on timeline
    },
    mutations: {
        STAFF_TIMELINE_SCHEDULES(state, payload) {
            state.staffs = payload.staffList
            state.schedules = payload.calendarListView
        },
    },
    actions: {
        // @Description 직원 중심의 타임라인 스케줄 조회
        async STAFF_TIMELINE_SCHEDULES({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await timeline.get.staffTimeline(payload)
                
                console.log('STAFF_TIMELINE_SCHEDULES info', res)
                
                if (res.data.status === 200) { // success
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                    commit('STAFF_TIMELINE_SCHEDULES', res.data.data)
                } else { // not 200 answer code
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
                }
                store.commit('CLOSE_LOADING')
                return res.data // must return cause of Ymd set with exact time
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_TIMELINE_SCHEDULES error', error)
            }
        },
        // @Description 종사자 일정 변경
        async CHANGE_STAFF_SCHEDULE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await timeline.post.changeReceiverOfferScheduleStaff(payload)

                console.log('CHANGE_STAFF_SCHEDULE info', res)

                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_STAFF_SCHEDULE error', error)
            }
        },
        // @Description 종사자 일정 삭제
        async DELETE_STAFF_SCHEDULE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await timeline.delete.changeReceiverOfferSchedule(payload)

                console.log('DELETE_STAFF_SCHEDULE info', res)

                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_SCHEDULE error', error)
            }
        }
    },
    getters: {
        STAFF_TIMELINE_SCHEDULES: state => {
            if (state.staffs !== null) {
                state.staffs.forEach( (item, index) => {
                    if (typeof item.title === "undefined") {
                        state.staffs[index]['title'] = 
                            `${item.userName} (${item.mobileNo.telNo()})`
                    }
                })
            }

            if (state.schedules !== null) {
                state.schedules.forEach( (item, index) => {
                    if (typeof item.title === "undefined") {
                        state.schedules[index]['title'] = 
                            `${item.receiverUserName} (${(item.homeServiceTypeCode==='11')?'방문요양':'방문목욕'})`
                    }

                    if (typeof item.color === "undefined") {
                        state.schedules[index]['color'] = `#${item.colorCode}`
                    }
                })
            }

            let data = (state.staffs === null) ? null : {
                resources: state.staffs,
                events: state.schedules,
            }

            return data
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/timelines.js